import script from "./KeysArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeysArea.vue?vue&type=script&setup=true&lang=ts"

import "./KeysArea.vue?vue&type=style&index=0&id=0e3ee519&lang=css"

const __exports__ = script;

export default __exports__